import { axiosInstance } from '@/lib/axios';
import { TimesheetConfigurationModelRaw } from './types';

type Props = {
  companyId: string
  payload: TimesheetConfigurationModelRaw
}

export function updateTimesheetBasicSettings({ companyId, payload }: Props) {
  return axiosInstance.post<TimesheetConfigurationModelRaw>(`/api/${companyId}/configuration/saveTimesheetConfiguration`, {
    configuration: payload
  });
}
